import { render } from "./CardRequest.vue?vue&type=template&id=bcef50f6"
import script from "./CardRequest.vue?vue&type=script&lang=js"
export * from "./CardRequest.vue?vue&type=script&lang=js"

import "./CardRequest.vue?vue&type=style&index=0&id=bcef50f6&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__